import { FormattedMessage } from "react-intl";

const UnlimitedProjects = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.unlimitedProjectBoards.content.body.v2"
                    defaultMessage="Align projects and tasks to goals. Collect data with forms."
                />
            </p>
        </div>
    );
};

export default UnlimitedProjects;
